//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Model from "@/models/yunMobile";
import confim from "./confimRecharge";
import PayCommon from "./PayCommon";
export default {
  components: {
    confim,
    PayCommon
  },
  data() {
    return {
      checkedIndex: 0,
      userMoney: 0,
      authCode: "",
      list: [],
      submitState: false
    };
  },
  computed: {
    row() {
      return this.list.find((item, index) => index == this.checkedIndex);
    },
    rechargeMoney() {
      let price = this.row ? this.row.discountPrice : 0,
        count = this.row ? this.row.count : 0;
      return price.mul(count);
    },
    payMoney() {
      return this.row ? this.row.payPrice : 0;
    },
    discountType() {
      return this.row ? this.row.discountType : 1;
    },
    count() {
      return this.row ? this.row.count : 0;
    }
  },
  methods: {
    choose(index) {
      this.checkedIndex = index;
    },
    onSubmit() {
      if (!this.payMoney) {
        this.$message.info("支付金额不能为0");
      } else {
        this.$refs.confim.visible = !this.$refs.confim.visible;
      }
    },
    countChange(value, index) {
      this.list = this.list.map((item, i) => {
        if (index == i) {
          item.payPrice = item.buyPrice.mul(item.count);
        }
        return item;
      });
    },
    async getRuleList() {
      let { data } = await Model.getRuleList();
      if (data.success) {
        this.list = data.list.map(item => {
          item.count = 1;
          item.discountType = item.youhuiquanType;
          item.payPrice = item.buyPrice.mul(1);
          return item;
        });
      }
    },
    async getUserMoney() {
      let { data } = await Model.getUserMoney(this.$route.params.userTel);

      if (data.success) {
        this.userMoney = data.list;
      }
    },
    async buyRule() {
      if (this.submitState) return;
      this.submitState = true;
      const { ruleNo, count } = this.row;
      let { data } = await Model.buyRule({
        ruleNo: ruleNo,
        bugNums: count
      });
      if (data.success) {
        let params = {
          orderNo: data.list.orderNo,
          orderAmount: data.list.payAmount,
          gsBh: data.list.gsbh,
          xmBh: data.list.xmbh,
          parkNo: data.list.parkNo,
          notifyType: 2
        };

        if (this.$isWx) {
          params.pageType = "recharge";
          params.pageUrl = location.href;
          sessionStorage.setItem("wxPayParams", JSON.stringify(params));
          const basUrl =
            location.protocol === "https:"
              ? "https://ycc-test-front.hnchxwl.com"
              : "http://dzbus.iot.xin";
          const payUrl =
            process.env.NODE_ENV == "production"
              ? basUrl
              : "http://192.168.8.192:8080";
          var url =
            payUrl +
            "/mobile/yunMobile/confirmPay/666?params=" +
            JSON.stringify(params);
          if (location.assign) {
            location.assign(url);
          } else {
            window.open(url);
          }
          return;
        } else if (this.$isZfb) {
          params.zhifuFs = "alipay_scan";
          params.code = this.authCode;
          this.$refs.payCommon.payByZfb({
            params,
            success: res => {
              this.$router.go(0);
            },
            fail: res => {
              this.$layer.msg(res.error || res.message);
            }
          });
        }
      } else {
        this.$layer.msg(data.error);
      }
      this.submitState = false;
    }
  },
  mounted() {
    console.log(location.protocol);

    if (this.$isZfb) {
      ap.getAuthCode(
        {
          appId: "2016060201473949",
          scopes: ["auth_user"]
        },
        res => {
          this.authCode = res.authCode;
        }
      );
    }
  },
  created() {
    localStorage.setItem("access_token", this.$route.params.token);
    this.getUserMoney();
    this.getRuleList();
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/recharge.vue